import { all, takeEvery, put, fork, call } from "redux-saga/effects";
// import { createBrowserHistory } from "history";
import { getToken, clearToken } from "../../utils/utility";
import actions from "./actions";
import { login, getUser, register } from "../../services/authService";
import { editQuizRequest } from "../../services/quizService";
import { notification } from "antd";

// const history = createBrowserHistory();

export function* loginRequest(payload) {
  try {
    const response = yield call(login, payload);
    if (response[0] === 200) {
      localStorage.setItem("id_token", response[1]["jwtToken"]);
      localStorage.setItem(
        "accessInformation",
        JSON.stringify(response[1]["accessInformation"])
      );
      localStorage.setItem("status", response[1]["status"]);
      localStorage.setItem(
        "fullName",
        response[1]["firstName"] + " " + response[1]["lastName"]
      );

      yield put({
        type: actions.LOGIN_SUCCESS,
        token: response[1]["jwtToken"],
        accessInformation: response[1]["accessInformation"],
      });

      if (
        response[1]["organizations"].length > 0 &&
        response[1]["organizations"][0]["id"] !== undefined &&
        response[1]["organizations"][0]["id"] > 0
      ) {
        localStorage.setItem(
          "organizationId",
          response[1]["organizations"][0]["id"]
        );
        localStorage.setItem(
          "organization",
          response[1]["organizations"][0]["name"]
        );
        localStorage.setItem(
          "displayName",
          response[1]["organizations"][0]["displayNameBulgarian"]
        );
        localStorage.setItem(
          "hotelEnabled",
          response[1]["organizations"][0]["hotelEnabled"]
        );
      } else if (
        response[1]["organizations"].length > 0 &&
        response[1]["organizations"].filter((o) => o.isChecked).length === 0
      ) {
        window.location = "/permission-denied";
      }
    } else if (response[0] === 429) {
      notification["error"]({
        message: "Грешка",
        description: "Прекалено много заявки. Моля, опитайте по-късно.",
      });
    } else {
      if (response[0] === 404) {
        notification["error"]({
          message: "Грешка",
          description: "Грешно потребителско име или парола!",
        });
      } else {
        let msg = "";
        if (response[1].errors !== undefined) {
          const errorMessages = [];
          for (let error in response[1].errors) {
            response[1].errors[error].forEach((errorMessage) => {
              errorMessages.push(errorMessage);
            });
          }
          msg += errorMessages.join(" ");
        }
        if (response[1]["title"] !== undefined) {
          msg += response[1]["title"];
        }
        notification["error"]({
          message: "Грешка",
          description: msg,
        });
      }
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка",
    });
  }
}

export function* loginSuccess() {
  yield takeEvery(actions.LOGIN_SUCCESS, function* (payload) {
    yield localStorage.setItem("id_token", payload.token);
  });
}

export function* loginError() {
  yield takeEvery(actions.LOGIN_ERROR, function* () {});
}

export function* logout() {
  yield takeEvery(actions.LOGOUT, function* () {
    let preference = localStorage.getItem("preference");
    let versions = localStorage.getItem("versions");
    let organizationId = localStorage.getItem("organizationId");
    localStorage.clear();

    localStorage.setItem("preference", preference);
    localStorage.setItem("versions", versions);
    localStorage.setItem("organizationId", organizationId);

    yield clearToken();
    // history.push("/");
  });
}

export function* checkAuthorization() {
  const token = getToken().get("idToken");
  const oldAccess =
    JSON.parse(localStorage.getItem("accessInformation"))?.length || 0;
  const oldOrganizationId = localStorage.getItem("organizationId");
  const oldStatus = localStorage.getItem("status");

  if (token) {
    const response = yield call(getUser, token);
    if (response[0] === 200) {
      yield put({
        type: actions.LOGIN_SUCCESS,
        token: token,
        userId: response[1].id,
        userSurveyStatus: response[1].userSurveyStatus,
        accessInformation: response[1]["accessInformation"],
      });
      localStorage.setItem("id_token", response[1]["jwtToken"]);
      localStorage.setItem("status", response[1]["status"]);
      localStorage.setItem(
        "fullName",
        response[1]["firstName"] + " " + response[1]["lastName"]
      );

      const isCheckedOrganizations = response[1]["organizations"].filter(
        (o) => o.isChecked
      );
      if (isCheckedOrganizations.length > 0 && oldOrganizationId === null) {
        localStorage.setItem("organization", isCheckedOrganizations[0]["name"]);
        localStorage.setItem("displayName", isCheckedOrganizations[0]["name"]);
        localStorage.setItem("organizationId", isCheckedOrganizations[0]["id"]);
        localStorage.setItem(
          "hotelEnabled",
          isCheckedOrganizations[0]["hotelEnabled"]
        );
      }
      localStorage.setItem(
        "accessInformation",
        JSON.stringify(response[1]["accessInformation"])
      );

      if (
        oldAccess !== response[1]["accessInformation"].length ||
        JSON.parse(response[1]["status"]) !== JSON.parse(oldStatus)
      ) {
        localStorage.setItem("status", response[1]["status"]);

        if (
          response[1]["organizations"].filter((o) => o.isChecked).length < 0
        ) {
          window.location = "/permission-denied";
        }
      }
    }
  }
}

export function* registerRequest({ user }) {
  try {
    const response = yield call(register, user);
    if (response[0] === 200) {
      localStorage.setItem("id_token", response[1]["jwtToken"]);
      localStorage.setItem("role", response[1]["role"]);
      localStorage.setItem("status", response[1]["status"]);
      localStorage.setItem("organization", response[1]["organization"]);
      localStorage.setItem("organizationId", response[1]["organizationId"]);
      localStorage.setItem(
        "fullName",
        response[1]["firstName"] + " " + response[1]["lastName"]
      );

      window.location = "/permission-denied";

      notification["success"]({
        message: "Успешена регистрация.",
      });

      yield put({
        type: actions.REGISTER_SUCCESS,
        user: response[1],
      });
    } else {
      let msg = "";

      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }

      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }

      notification["error"]({
        message: "Неуспешна регистрация.",
        description: msg,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Неуспешна регистрация.",
    });
  }
}

export function* editQuiz(data) {
  try {
    const token = getToken().get("idToken");
    const response = yield call(
      editQuizRequest,
      data.value,
      data.userId,
      token
    );
    if (response[0] === 200) {
      yield put({
        type: actions.USER_SURVEY_STATUS_SUCCESS,
      });
      notification["success"]({
        message: "Успешено изпращане",
      });
    } else {
      let msg = "";
      if (response[1].errors !== undefined) {
        const errorMessages = [];
        for (let error in response[1].errors) {
          response[1].errors[error].forEach((errorMessage) => {
            errorMessages.push(errorMessage);
          });
        }
        msg += errorMessages.join(" ");
      }
      if (response[1]["title"] !== undefined) {
        msg += response[1]["title"];
      }
      notification["error"]({
        message: "Грешка, неуспешно изпращане",
        description: msg,
      });
    }
  } catch (error) {
    notification["error"]({
      message: "Грешка",
    });
  }
}

export function* registerSuccess() {
  yield takeEvery(actions.REGISTER_SUCCESS, function* (payload) {
    yield localStorage.setItem("id_token", payload.token);
  });
}

export default function* rootSaga() {
  yield all([
    yield takeEvery(actions.LOGIN_REQUEST, loginRequest),
    yield takeEvery(actions.CHECK_AUTHORIZATION, checkAuthorization),
    yield takeEvery(actions.REGISTER_REQUEST, registerRequest),
    yield takeEvery(actions.REGISTER_SUCCESS, registerSuccess),
    yield takeEvery(actions.USER_SURVEY_STATUS_REQUEST, editQuiz),
    fork(loginSuccess),
    fork(loginError),
    fork(logout),
  ]);
}
